import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import "./index.css"
import React from "react"
import ReactDOM from "react-dom"
import { Auth0Provider } from "@auth0/auth0-react"
import App from "./App"
import LogRocket from "logrocket"
import setupLogRocketReact from "logrocket-react"

if (process.env.NODE_ENV !== "development") {
    LogRocket.init("h6w8xp/holtzman-suite-prod")
    setupLogRocketReact(LogRocket)
}

ReactDOM.render(
    <Auth0Provider
        domain="cazireth.us.auth0.com"
        clientId="7QmAmGnFvU2A8d534NuxuK43C0cwQvOF"
        redirectUri={window.location.origin}
        authorizationParams={{
            audience: "https://rentalsuite.cazireth.com",
            scope: "read",
            redirect_uri: window.location.origin,
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
    >
        <App />
    </Auth0Provider>,
    document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
